import React, { useState } from "react";
import { Apple, MessageCircle } from "lucide-react";
import MealChatbot from "./MealChatbot";

const MealPlanWidget = ({ data }) => {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  // Sin comidas de ejemplo: antes, un atleta que no había registrado nada veía
  // "Avena con frutas" y "Pollo con quinoa" como si fueran suyas, con calorías
  // inventadas. Un estado vacío dice la verdad.
  const hasMeals = Array.isArray(data) && data.length > 0;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 h-full">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Apple className="text-orange-500" size={20} />
          <h3 className="font-semibold text-gray-900">Plan de Comidas</h3>
        </div>

        {/* Botón del Chatbot */}
        <button
          onClick={() => setIsChatbotOpen(true)}
          className="flex items-center gap-2 px-3 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors duration-200 text-sm shadow-sm"
        >
          <MessageCircle size={16} />
          <span className="hidden sm:inline">Chat IA</span>
        </button>
      </div>

      {/* Lista de Comidas */}
      {hasMeals ? (
        <div className="space-y-4">
          {data.map((meal, index) => (
            <div
              key={meal.key || index}
              className="flex gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors"
            >
              {/* Sin fallback a via.placeholder.com: es un dominio externo que
                  ya no resuelve, así que rompía la tarjeta en vez de rellenarla.
                  Si no hay foto, no se reserva el hueco. */}
              {meal.image && (
                <img
                  src={meal.image}
                  alt={meal.description || meal.name || meal.meal || "Comida"}
                  className="w-16 h-16 rounded-lg object-cover shadow-sm"
                />
              )}
              <div className="flex-1 flex flex-col justify-center">
                <div className="flex items-center justify-between mb-1">
                  <h4 className="text-sm font-bold text-gray-900">
                    {meal.meal || "Comida"}
                  </h4>
                  {meal.size && (
                    <span className="text-xs font-medium px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full">
                      {meal.size}
                    </span>
                  )}
                </div>
                {(meal.description || meal.name) && (
                  <p className="text-sm text-gray-700 mb-0.5 leading-tight">
                    {meal.description || meal.name}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="rounded-lg border border-dashed border-gray-200 px-4 py-8 text-center">
          <p className="text-sm text-gray-600">
            Todavía no registraste comidas hoy.
          </p>
          <p className="mt-1 text-xs text-gray-500">
            Usa el Chat IA para añadir la primera.
          </p>
        </div>
      )}

      <MealChatbot
        isOpen={isChatbotOpen}
        onClose={() => setIsChatbotOpen(false)}
      />
    </div>
  );
};

export default MealPlanWidget;
